import { useEffect, useState } from 'react';

/**
 * A altura real de um elemento, em pixels.
 *
 * O `ResponsiveContainer` do recharts mede o pai, e `height="100%"` só resolve
 * quando esse pai tem altura EXPLÍCITA — altura vinda de `flex: 1` devolve zero e
 * o gráfico não desenha. Posicionar a caixa com `inset` também não se mostrou
 * confiável aqui. Medir e passar o número resolve de uma vez, e acompanha o
 * redimensionamento da janela.
 *
 * A ref é de callback: o elemento pode nascer depois do primeiro render (a tela
 * carregando, um bloco que só aparece com dado) e ainda assim passa a ser medido.
 */
export function useAltura<T extends HTMLElement>() {
    const [el, setEl] = useState<T | null>(null);
    const [altura, setAltura] = useState(0);

    useEffect(() => {
        if (!el) return;
        const observador = new ResizeObserver(([entrada]) => {
            setAltura(Math.round(entrada.contentRect.height));
        });
        observador.observe(el);
        return () => observador.disconnect();
    }, [el]);

    return [setEl, altura] as const;
}
